import { TDrawerSize } from '@/components/Drawer/Drawer.types.ts';

export const DRAWER_SIZE: Record<TDrawerSize, string> = {
    xs: '25%',
    sm: '33%',
    md: '50%',
    lg: '66%',
    xl: '75%',
    full: '100%'
};
